var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBtnFinish = function SvgBtnFinish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.7l-4.5 4.5-1.2-1.4a.8.8 0 00-1.1 1l1.7 2a.7.7 0 001.1 0l5-5a.8.8 0 00-1-1"
  })));
};
export default SvgBtnFinish;